import { axios } from '@/lib/axios';

export const getUsers = async (filters?: {
  isActivated?: string;
  isSuspended?: string;
  email?: string;
  name?: string;
}) => {
  const params: any = { pageSize: 5000 };

  if (filters?.isActivated) params.isActivated = filters.isActivated;
  if (filters?.isSuspended) params.isSuspended = filters.isSuspended;
  if (filters?.email) params.email = filters.email;
  if (filters?.name) params.name = filters.name;

  const resp = await axios.get('/users', { params });
  return resp.data;
};

export const getUsersStats = async () => {
  const resp = await axios.get(`/users/status/stat`);
  return resp.data;
};

export const deleteUser = async (_id: string) => {
  const resp = await axios.delete(`/users/${_id}`);
  return resp.data;
};

export const suspendUser = async (_id: string) => {
  const resp = await axios.patch(
    `/users/${_id}/suspend`,
    //  {
    //   isSuspended: true,
    // }
  );
  return resp.data;
};
